<div class="p-4">
  <div class="">
    <div class="text-center">
      <h4 class="title-card">Attribute Multiple Items</h4>
    </div>
  </div>

  <hr class="divider" />

  <div class="flex-container" *ngIf="!showContainer && !showVirtualContainer">
    <mat-form-field>
      <mat-label>Add By:</mat-label>
      <mat-select
        name="choosesearch"
        (selectionChange)="chooseSearch($event.value)"
        [(ngModel)]="choosesearch"
      >
        <mat-option *ngFor="let v of searchvalues" [value]="v.value">
          {{ v.viewValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label *ngIf="choosesearch === 'inventory'">Inventory ID</mat-label>
      <mat-label *ngIf="choosesearch === 'id'">Dashboard ID</mat-label>
      <mat-label *ngIf="choosesearch === 'po'"
        >Search by PO and Line Item: XXXX-XXX (5050-001)</mat-label
      >
      <mat-label *ngIf="choosesearch === 'sn'">Serial Number</mat-label>
      <input
        type="text"
        matInput
        name="searchValue"
        [(ngModel)]="searchValue"
        (keyup.enter)="handleEnter()"
        required
      />
      <button
        matSuffix
        *ngIf="choosesearch !== 'po'"
        class="btn-only-text"
        [disabled]="searching || searchValue === ''"
        (click)="searchInventory()"
      >
        <app-icon name="fi-rr-search" class="main-gray"></app-icon>
      </button>
      <button
        matSuffix
        *ngIf="choosesearch === 'po'"
        class="btn-only-text"
        [disabled]="searching || searchValue === ''"
        (click)="getDataPO()"
      >
        <app-icon name="fi-rr-search" class="main-gray"></app-icon>
      </button>
    </mat-form-field>
    <app-filter-object
      class="w-100"
      placeholder="Container Inventory"
      *ngIf="!loadingContainers"
      [options]="containers"
      (selectChange)="saveContainer($event)"
    ></app-filter-object>
    <app-filter-object
      class="w-100"
      placeholder="Virtual Container Name"
      *ngIf="!loadingContainers"
      [options]="virtualContainers"
      (selectChange)="saveVirtualContainer($event)"
    ></app-filter-object>
    <!-- <mat-form-field>
                <mat-label>Virtual Container Name</mat-label>
                <input
                  type="text"
                  matInput
                  name="virtualname"
                  [(ngModel)]="virtualContainerName"
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field> -->
    <!-- <button
    [disabled]="this.bulk.length == 0"
    class="btn btn-md btn-primary"
    (click)="procesar('container')"
    style="margin-bottom: 20px"
  >
    Assign Container ({{ bulk.length }})
  </button>

  &nbsp;&nbsp;

  <button
    [disabled]="this.bulk.length == 0"
    class="btn btn-md btn-primary"
    (click)="procesar('virtualcontainer')"
    style="margin-bottom: 20px"
  >
    Assign Virtual Container ({{ bulk.length }})
  </button> -->
  </div>
  <hr class="divider" />

  <div class="row" *ngIf="showContainer">
    <div class="col-12">
      <div mat-dialog-content>
        <div>
          <div style="background-color: #f2f3f4">
            <div class="row" style="margin-left: 3px; margin-right: 3px">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="bmd-label-floating"
                    ><b>Container Inventory</b> &nbsp;
                    <i
                      *ngIf="loadingContainers"
                      class="fa fa-spinner fa-pulse fa-fw"
                    ></i>
                  </label>
                  <app-filter-object
                    *ngIf="!loadingContainers"
                    [options]="containers"
                    (selectChange)="saveContainer($event)"
                  ></app-filter-object>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn btn-danger"
          (click)="cancelContainer()"
          style="margin-top: 20px"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="showVirtualContainer">
    <div class="col-12">
      <div mat-dialog-content>
        <div>
          <div>
            <div class="row" style="margin-left: 3px; margin-bottom: 3px">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Virtual Container Name</mat-label>
                  <input
                    type="text"
                    matInput
                    name="virtualname"
                    [(ngModel)]="virtualContainerName"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-form-field>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="btn btn-success btn-md"
                  (click)="addVirtualContainer()"
                  [disabled]="virtualContainerName === '' || savingcontainer"
                >
                  <i
                    *ngIf="!savingcontainer"
                    class="fa fa-floppy-o"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="savingcontainer"
                    class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
                  ></i>
                  &nbsp; Add Container
                </button>
              </div>
            </div>
          </div>

          <div style="background-color: #f2f3f4">
            <div class="row" style="margin-left: 3px; margin-right: 3px">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating"
                    ><b>Virtual Container Inventory</b> &nbsp;
                    <i
                      *ngIf="loadingContainers"
                      class="fa fa-spinner fa-pulse fa-fw"
                    ></i>
                  </label>
                  <app-filter-object
                    *ngIf="!loadingContainers"
                    [options]="virtualContainers"
                    (selectChange)="saveVirtualContainer($event)"
                  ></app-filter-object>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn btn-danger"
          (click)="cancelContainer()"
          style="margin-top: 20px"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="notFound" style="text-align: center; padding: 20px">
    <div
      class="alert alert-danger"
      role="alert"
      style="font-size: 1.4rem; font-weight: 500"
    >
      {{ mensajeError }}
    </div>
  </div> -->

  <div *ngIf="!loading" class="flex-container justify-space-between">
    <dinamic-table
      *ngIf="!loading"
      [id]="'attributeMultipleTable'"
      [data]="multipleData"
      style="width: 100%"
      [columnfilters]="filtros"
      [dbname]="'attributeMultipleList'"
    ></dinamic-table>
    <div
      class="scrollClass pl-2"
      style="width: 40%"
      (wheel)="stopPropagation($event)"
    >
      <div>
        <a role="button" (click)="AddMasterShow()" style="cursor: pointer">
          <strong style="font-weight: bold">Add Master Category</strong>
          <button mat-icon-button (click)="AddMasterShow()">
            <mat-icon>add</mat-icon>
          </button>
        </a>

        <div class="flex-container" *ngIf="addmaster">
          <mat-form-field>
            <input
              type="text"
              name="masterCategory"
              [(ngModel)]="masterCategory"
              matInput
              placeholder="Master Category"
            />
          </mat-form-field>
          <div>
            <button class="border" mat-button (click)="AddCategoryNew()">
              Save
            </button>
          </div>
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodeToggle
            matTreeNodePadding
          >
            <button mat-icon-button disabled></button>
            <mat-checkbox
              class="checklist-leaf-node"
              [checked]="checklistSelection.isSelected(node)"
              (change)="todoLeafItemSelectionToggle(node)"
              >{{ node.label }}</mat-checkbox
            >
            <button mat-icon-button (click)="addNewItem(node)">
              <mat-icon>add</mat-icon>
            </button>
          </mat-tree-node>

          <mat-tree-node
            *matTreeNodeDef="let node; when: hasNoContent"
            matTreeNodePadding
          >
            <button mat-icon-button disabled></button>
            <button
              mat-icon-button
              (click)="deleteInputItem(node)"
              *ngIf="ids_add.length > 0"
            >
              <mat-icon>remove</mat-icon>
            </button>
            <input
              type="text"
              class="form-control"
              name="itemValue"
              [(ngModel)]="itemValue"
              placeholder="New item..."
              *ngIf="ids_add.includes(node.is_father)"
            />
            <button
              mat-button
              (click)="saveNode(node)"
              *ngIf="ids_add.includes(node.is_father)"
            >
              Save
            </button>
          </mat-tree-node>

          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
          >
            <button
              mat-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.filename"
            >
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
                }}
              </mat-icon>
            </button>
            <mat-checkbox
              [checked]="descendantsAllSelected(node)"
              [indeterminate]="descendantsPartiallySelected(node)"
              (change)="todoItemSelectionToggle(node)"
              >{{ node.label }}</mat-checkbox
            >
            <button mat-icon-button (click)="addNewItem(node)">
              <mat-icon>add</mat-icon>
            </button>
          </mat-tree-node>
        </mat-tree>
      </div>
    </div>
  </div>

  <div class="flex-container justify-content-end mt-4">
    <app-button-primary
      (clickBtn)="close()"
      [outlineDanger]="true"
      iconLeftCustom="fi-rr-circle-x"
      label="Close"
    >
    </app-button-primary>
    <div>
      <div class="d-flex">
        <app-button-primary
          [outline]="true"
          matRipple
          [matMenuTriggerFor]="menu2"
          iconRight="arrow_drop_down"
          label="Actions"
          [borderRight]="true"
        >
        </app-button-primary>
        <!-- Botón de acción principal -->

        <!-- Botón de desplegar el menú -->
        <!-- <button
          matRipple
          class="gts-btn-primary-outline spl"
          [matMenuTriggerFor]="menu2"
        >
          <mat-icon class="iconArrow mat-icon show-overflow"
            >arrow_drop_down</mat-icon
          >
        </button> -->
      </div>

      <!-- Menú desplegable -->
      <mat-menu #menu2="matMenu" class="custom-menu my-po-menu">
        <div class="menu-item-container">
          <button mat-button class="menu-option" (click)="procesar('test', 0)">
            Mark Untested ({{ bulk.length }})
          </button>

          <button mat-button class="menu-option" (click)="procesar('test', 1)">
            Mark Tested ({{ bulk.length }})
          </button>
          <button
            mat-button
            class="menu-option"
            (click)="removeAttributesModal()"
          >
            Remove Attributes ({{ bulk.length }})
          </button>
        </div>
      </mat-menu>
    </div>
    <!-- <button type="button" class="btn btn-danger btn-md" (click)="close()">
        Close
      </button> -->
    <app-button-primary
      (clickBtn)="save()"
      [primary]="true"
      iconLeftCustom="fi-rr-disk"
      label="Save"
      [disabled]="!isDirty"
    >
    </app-button-primary>
  </div>
</div>

<div
  class="modal fade"
  id="modalDelete"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!--<h3 class="modal-title" id="exampleModalScrollableTitle"> <b>Are you sure you want to remove attributes?</b></h3>-->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <p>
          <strong>Are you sure you want to remove attributes?</strong>
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-dismiss="modal">
          Cancel
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-danger"
          (click)="removeAttributes()"
        >
          <i *ngIf="saving" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
          Remove
        </button>
      </div>
    </div>
  </div>
</div>
